import * as React from 'react'
import { IProviderProps } from '@user/components/Filters'
import { ActivityStatusOptions } from '@user/features/Activity'

export const ActivityStatusProvider: React.FC<IProviderProps> = ({
  render,
}) => {
  return <>{render(ActivityStatusOptions ?? [], false)}</>
}
ActivityStatusProvider.displayName = 'ActivityStatusProvider'
